import React, { FC } from 'react'
import { Button } from 'transfix-ui/components/Button'
import FleetCalendarIllustration from 'apps/fleet-planner/components/illustrations/onboarding/FleetCalendar.svg'

export interface IFleetDeskTopReminderProps {
  isOpen: boolean
  onClose: () => void
}

export const FleetDesktopReminder: FC<IFleetDeskTopReminderProps> = ({ isOpen, onClose }) => {
  return (
    <div
      className={`${
        isOpen ? 'flex' : 'dn'
      } full-screen flex-column justify-center items-center bg-default`}>
      <div className='col-xs-10'>
        <img src={FleetCalendarIllustration} alt='Fleet Calendar Illustration' />
      </div>
      <div className='col-xs-10 tc'>
        <h2 className='mt6'>Your schedule is optimized for desktop</h2>
        <div className='mt4 body-medium'>For the best experience, use a desktop browser.</div>
      </div>
      <div className='mt6 col-xs-4'>
        <Button color='primary' fullWidth data-test='dismiss-action' size='large' onClick={onClose}>
          Dismiss
        </Button>
      </div>
    </div>
  )
}
